export default "__VITE_ASSET__CZHnMVVS__"